import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Featured Videos</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">精彩推荐</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">精选推荐内容，发现你的下一部好剧</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <article key={item.id} className="bg-background-100 rounded-lg overflow-hidden border border-secondary-200/60 group cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs bg-black/60 backdrop-blur-sm text-background-50 px-2.5 py-1 rounded-full">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-accent-500 text-background-50 px-2.5 py-0.5 rounded-full">
                    {item.type}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 line-clamp-2">{item.title}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}